import {useUserState} from "../store/user-store";
import {UserSettingsApi} from "../api/UserSettingsApi";


export const UserService = {
    getUserInfo: async () => {
        const userRes = await UserSettingsApi.userInfo();
        if(!userRes.data) {
            console.error("Failed to get current user");
            return undefined;
        } else {
            return userRes.data;
        }
    },

    initUser: () => {
        UserService.getUserInfo().then((user) => {
            console.log("Current user info loaded!")
            useUserState.getState().setCurrentUser(user);
        })
    }
}